import styled from 'styled-components';

const PaddingRightSpan = styled.span`
  padding-right: 5px;
`;

export default PaddingRightSpan;
